import {
  OutlineButton,
  SolidButton,
} from "@/components/StoreComponents/StoreButton";
import { ComponentProps } from "react";

export const CheckoutButton = (
  props: ComponentProps<typeof OutlineButton> & { submitting?: boolean }
) => {
  const { disabled, submitting, ...rest } = props;

  if (disabled) {
    return <OutlineButton disableMaxWidth {...rest} disabled />;
  }

  if (submitting) {
    return <SolidButton disableMaxWidth {...rest} onClick={() => {}} />;
  }

  return <SolidButton disableMaxWidth {...rest} />;
};
